// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IProcessedReturnedCheckDetailsDtoProcessingDecision } from './IProcessedReturnedCheckDetailsDtoProcessingDecision';
import {
    IProcessedReturnedCheckDetailsDtoProcessingDecisionFromJSON,
    IProcessedReturnedCheckDetailsDtoProcessingDecisionFromJSONTyped,
    IProcessedReturnedCheckDetailsDtoProcessingDecisionToJSON,
    IProcessedReturnedCheckDetailsDtoProcessingDecisionToJSONTyped,
} from './IProcessedReturnedCheckDetailsDtoProcessingDecision';

/**
 * 
 * @export
 * @interface IProcessedReturnedCheckDetailsDto
 */
export interface IProcessedReturnedCheckDetailsDto {
    /**
     * 
     * @type {number}
     * @memberof IProcessedReturnedCheckDetailsDto
     */
    check_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IProcessedReturnedCheckDetailsDto
     */
    check_type?: IProcessedReturnedCheckDetailsDtoCheckTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof IProcessedReturnedCheckDetailsDto
     */
    check_amount?: number;
    /**
     * 
     * @type {IProcessedReturnedCheckDetailsDtoProcessingDecision}
     * @memberof IProcessedReturnedCheckDetailsDto
     */
    processing_decision?: IProcessedReturnedCheckDetailsDtoProcessingDecision;
}

/**
* @export
* @enum {string}
*/
export enum IProcessedReturnedCheckDetailsDtoCheckTypeEnum {
    LOCKBOX = 'LOCKBOX',
    PARTICIPANT = 'PARTICIPANT',
    PROVIDER = 'PROVIDER'
}


/**
 * Check if a given object implements the IProcessedReturnedCheckDetailsDto interface.
 */
export function instanceOfIProcessedReturnedCheckDetailsDto(value: object): value is IProcessedReturnedCheckDetailsDto {
    return true;
}

export function IProcessedReturnedCheckDetailsDtoFromJSON(json: any): IProcessedReturnedCheckDetailsDto {
    return IProcessedReturnedCheckDetailsDtoFromJSONTyped(json, false);
}

export function IProcessedReturnedCheckDetailsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IProcessedReturnedCheckDetailsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'check_id': json['check_id'] == null ? undefined : json['check_id'],
        'check_type': json['check_type'] == null ? undefined : json['check_type'],
        'check_amount': json['check_amount'] == null ? undefined : json['check_amount'],
        'processing_decision': json['processing_decision'] == null ? undefined : IProcessedReturnedCheckDetailsDtoProcessingDecisionFromJSON(json['processing_decision']),
    };
}

export function IProcessedReturnedCheckDetailsDtoToJSON(json: any): IProcessedReturnedCheckDetailsDto {
    return IProcessedReturnedCheckDetailsDtoToJSONTyped(json, false);
}

export function IProcessedReturnedCheckDetailsDtoToJSONTyped(value?: IProcessedReturnedCheckDetailsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'check_id': value['check_id'],
        'check_type': value['check_type'],
        'check_amount': value['check_amount'],
        'processing_decision': IProcessedReturnedCheckDetailsDtoProcessingDecisionToJSON(value['processing_decision']),
    };
}

